import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safeHtml', standalone: true })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer){}
  transform(value: string | null | undefined): any {
    return this.sanitized.bypassSecurityTrustHtml(value ?? '');
  }
}
